import { TLocalizedString } from "libraries/pipes/localized/localized.interface";

export enum LinesType {
    booking = 'booking',
    processing = 'processing',
}

export interface IDefaultSearchParametersHome {
    booking: IBookingNbrRecord;
    processing: IProcessingNbrRecord;
    quickAccessQueries?: IQuickAccessQueries;
}

export const DEFAULT_SEARCH_PARAMETERS_HOME: IDefaultSearchParametersHome = {
    booking: { nbrecord: 30 },
    processing: { nbrecord: 5 },
};

export interface IQuickAccessQueries {
    title: TLocalizedString;
    lines: IQueryLine[];
}

export interface IQueryLine {
    title: TLocalizedString;
    queryString: string;
    type: LinesType;
}

export interface IBookingNbrRecord {
    nbrecord: number;
}

export interface IProcessingNbrRecord {
    nbrecord: number;
}